import { render, staticRenderFns } from "./SelectWasteOrServiceModal.vue?vue&type=template&id=3edfb62e&scoped=true&"
import script from "./SelectWasteOrServiceModal.vue?vue&type=script&lang=js&"
export * from "./SelectWasteOrServiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edfb62e",
  null
  
)

export default component.exports